package one.healthium.meal_plans.tutorial.di

import one.healthium.meal_plans.di.mealPlansDataModule
import one.healthium.meal_plans.tutorial.screen.PersonalMealPlanTutorialViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val mealPlanTutorialModule = module {
    includes(mealPlansDataModule)

    viewModelOf(::PersonalMealPlanTutorialViewModel)
}